module.exports = __webpack_public_path__ + "img/video-poster-desktop.d929318.webp";